import { createApi } from '@reduxjs/toolkit/query/react';
import { ENDPOINT_CONSTANTS } from '../../constant';
import uploadBaseQuery from 'service/uploadBaseQuery/uploadBaseQuery';

export const uploadQuery = createApi({
  reducerPath: 'uploadQuery',
  baseQuery: uploadBaseQuery,
  endpoints: builder => ({
    uploadSingle: builder.mutation({
      query: body => ({
        url: ENDPOINT_CONSTANTS.UPLOAD,
        method: 'POST',
        body
      })
    }),
    updateSingleFile: builder.mutation({
      query: body => ({
        url: ENDPOINT_CONSTANTS.UPLOAD,
        method: 'PUT',
        body
      })
    })
  })
});

export const { useUploadSingleMutation, useUpdateSingleFileMutation } =
  uploadQuery;
